import React, { ReactNode } from 'react';
import { makeStyles } from '@material-ui/core';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';

const useStyles = makeStyles(theme => ({
  root: {
    [theme.breakpoints.up('sm')]: {
      '& > div, & > fieldset, & > p': {
        marginLeft: theme.spacing(3),
        marginRight: theme.spacing(3),
      },
    },
    [theme.breakpoints.down('sm')]: {
      '& > div, & > fieldset, & > p': {
        marginLeft: theme.spacing(1),
      }
    },
    '& > h1,h2,h3,h4,h5,h6': {
      marginLeft: 0,
      marginRight: 0,
    },
  },
}));

type FormSectionProps = {
  children: ReactNode,
  subtitle?: ReactNode,
  title: ReactNode,
}

const FormSection = ({ children, subtitle, title }: FormSectionProps) => {
  const classes = useStyles();
  
  return (
    <Box className={classes.root} mb={4}>
      <Typography variant="h4">{title}</Typography>
      {subtitle && (
        <Typography variant="subtitle1">{subtitle}</Typography>
      )}
      {children}
    </Box>
  );
}

export default FormSection;
